import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

const { FiMail, FiClock, FiMapPin, FiPhone } = FiIcons;

const Contact = () => {
  return (
    <div className="py-20 bg-slate-50">
      <div className="container px-4 mx-auto max-w-6xl">
        <div className="max-w-3xl mx-auto mb-16 text-center">
          <h1 className="mb-6 text-4xl font-bold md:text-5xl text-primary">Get in touch</h1>
          <p className="text-xl text-slate-600">Have questions about Review Builder Pro? Our team is here to help.</p>
        </div>

        <div className="flex flex-col gap-12 lg:flex-row">
          <div className="lg:w-1/3 space-y-8">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-white rounded-lg shadow-sm text-secondary">
                <SafeIcon icon={FiMail} className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-bold text-primary mb-1">Email Support</h3>
                <p className="text-slate-600">support@reviewguru.au</p>
                <p className="text-sm text-slate-500 mt-1">We aim to reply within 24 hours.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="p-3 bg-white rounded-lg shadow-sm text-secondary">
                <SafeIcon icon={FiPhone} className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-bold text-primary mb-1">Phone</h3>
                <p className="text-slate-600">1300 30 11 33</p>
                <p className="text-slate-600">0455 455 433 (Peter)</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="p-3 bg-white rounded-lg shadow-sm text-secondary">
                <SafeIcon icon={FiClock} className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-bold text-primary mb-1">Business Hours</h3>
                <p className="text-slate-600">Monday - Friday</p>
                <p className="text-slate-600">9:00 AM - 6:00 PM AEST</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="p-3 bg-white rounded-lg shadow-sm text-secondary">
                <SafeIcon icon={FiMapPin} className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-bold text-primary mb-1">Mail PO Box</h3>
                <p className="text-slate-600">
                  PO Box 260<br/>
                  Hallam Victoria 3803
                </p>
              </div>
            </div>
          </div>

          <div className="lg:w-2/3">
            <div className="bg-white p-8 rounded-2xl shadow-soft">
              <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-3 rounded-lg border border-slate-200 bg-slate-50 focus:outline-none focus:ring-2 focus:ring-secondary focus:bg-white" 
                      placeholder="Your name" 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Email</label>
                    <input 
                      type="email" 
                      className="w-full px-4 py-3 rounded-lg border border-slate-200 bg-slate-50 focus:outline-none focus:ring-2 focus:ring-secondary focus:bg-white" 
                      placeholder="you@company.com" 
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Message</label>
                  <textarea 
                    rows="5" 
                    className="w-full px-4 py-3 rounded-lg border border-slate-200 bg-slate-50 focus:outline-none focus:ring-2 focus:ring-secondary focus:bg-white resize-none" 
                    placeholder="How can we help you?"
                  ></textarea>
                </div>
                <Button type="submit" variant="primary">Send Message</Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;